class WLSSearchForm extends HTMLElement {
  constructor() {
    super();
    
    this.classes = {
      loading: 'loading',
      active: 'active',
      resetButton: 'js-wls-search-show-reset-button',
      inputSearch: 'wls-search-form input[type="search"]'
    };

    // Bind methods to preserve context
    this.handleInput = this.handleInput.bind(this);
    this.handleReset = this.handleReset.bind(this);
    this.handleResetButtonClick = this.handleResetButtonClick.bind(this);
  }

  get elements() {
    return {
      form: this.querySelector('form'),
      input: this.querySelector('input[type="search"]'),
      resetButton: this.querySelector('button[type="reset"]'),
    };
  }

  connectedCallback() {
    this.init();
  }

  disconnectedCallback() {
    this.removeEventListeners();
  }

  init() {
    const { form, input } = this.elements;

    if (!input || !form) return;

    this.bindEvents();
    this.initializeState();
  }

  initializeState() {
    const { input } = this.elements;

    if (!input) return;
    
    const value = input.value;
    
    // Handle active class for forms with js-wls-search-show-reset-button
    document.querySelectorAll(`.${this.classes.resetButton}`).forEach((f) => {
      if (value) {
        f.classList.add(this.classes.active);
      } else {
        f.classList.remove(this.classes.active);
      }
    });
  }

  bindEvents() {
    const { input, form, resetButton } = this.elements;

    if (!input || !form || !resetButton) return;

    input.addEventListener('input', this.handleInput);
    form.addEventListener('reset', this.handleReset);
    
    if (resetButton) {
      resetButton.addEventListener('click', this.handleResetButtonClick);
    }
  }

  removeEventListeners() {
    const { input, form, resetButton } = this.elements;

    if (input) {
      input.removeEventListener('input', this.handleInput);
    }
    if (form) {
      form.removeEventListener('reset', this.handleReset);
    }
    if (resetButton) {
      resetButton.removeEventListener('click', this.handleResetButtonClick);
    }
  }

  handleInput(e) {
    const value = e.target.value;
    
    // Handle active class for forms with js-wls-search-show-reset-button
    document.querySelectorAll(`.${this.classes.resetButton}`).forEach((form) => {
      if (value) {
        form.classList.add(this.classes.active);
      } else {
        form.classList.remove(this.classes.active);
      }
    });

    // Sync input values across all search forms
    document.querySelectorAll(`${this.classes.inputSearch}`).forEach((input) => {
      if (input !== e.target) {
        input.value = value;
      }
    });
  }

  handleReset() {
    const { input } = this.elements;

    if (!input) return;

    input.value = '';
    input.focus();
    
    // Remove active class from forms with js-wls-search-show-reset-button
    document.querySelectorAll(`.${this.classes.resetButton}`).forEach((f) => {
      f.classList.remove(this.classes.active);
    });

    // Clear other search inputs
    document.querySelectorAll(`${this.classes.inputSearch}`).forEach((i) => {
      if (input !== i) {
        i.value = '';
      }
    });
  }

  handleResetButtonClick(e) {
    e.preventDefault();
    const { input } = this.elements;

    if (!input) return;

    input.value = '';
    input.focus();

    // Remove active class from forms with js-wls-search-show-reset-button
    document.querySelectorAll(`.${this.classes.resetButton}`).forEach((f) => {
      f.classList.remove(this.classes.active);
    });

    // Clear other search inputs
    document.querySelectorAll(`${this.classes.inputSearch}`).forEach((i) => {
      if (input !== i) {
        i.value = '';
      }
    });
  }

  setLoading() {
    this.setAttribute('disabled', true);
    this.classList.add(this.classes.loading);
  }

  removeLoading() {
    this.removeAttribute('disabled');
    this.classList.remove(this.classes.loading);
  }
}

if (!customElements.get('wls-search-form')) {
  customElements.define('wls-search-form', WLSSearchForm);
}
